// プライバシーポリシーチェックボックス
const privacyCheckBox = document.getElementById("privacy_check");
// 確認画面ボタン
const formConfirmBtn = document.getElementsByClassName("js-form__button");

// プライバシーポリシーチェック 設定
const setFromPrivacyCheck = () => {
  if (privacyCheckBox.checked) {
    // チェックの場合
    privacyCheckBox.value = 1;
    // 確認ボタンのclass削除
    Array.from(formConfirmBtn).forEach((btn) => {
      btn.classList.remove("is-disabled");
    });
  } else {
    // 未チェックの場合
    privacyCheckBox.value = 0;
    // 確認ボタンのclass追加
    Array.from(formConfirmBtn).forEach((btn) => {
      btn.classList.add("is-disabled");
    });
  }
};

// プライバシーポリシーチェック 変更時
if (privacyCheckBox) {
  privacyCheckBox.addEventListener("change", () => {
    // チェックに応じてClassと値変更
    setFromPrivacyCheck();
  });
}

// 確認画面ボタン クリック
Array.from(formConfirmBtn).forEach((btn) => {
  btn.addEventListener("click", (e) => {
    // プライバシーポリシーチェックが未チェックの場合
    if (!privacyCheckBox.checked) {
      e.preventDefault(); // 送信しない
    }
  });
});
